var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStopwatch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M513.347+264.381C345.032+264.381+208.585+400.827+208.585+569.143C208.585+737.458+345.032+873.905+513.347+873.905C681.662+873.905+818.109+737.458+818.109+569.143C818.109+400.827+681.662+264.381+513.347+264.381Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fill: "#2facec",
    d: "M513.347+912C322.871+912+170.49+759.619+170.49+569.143C170.49+378.667+322.871+226.286+513.347+226.286C703.823+226.286+856.204+378.667+856.204+569.143C856.204+759.619+703.823+912+513.347+912Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.347+864.143C349.458+864.143+218.347+733.032+218.347+569.143C218.347+405.254+349.458+274.143+513.347+274.143C677.236+274.143+808.347+405.254+808.347+569.143C808.347+733.032+677.236+864.143+513.347+864.143Z",
    fill: "#1a6ac9",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff7d6",
    opacity: 1,
    d: "M513.347+302.476C364.776+302.476+246.68+420.571+246.68+569.143C246.68+717.714+364.776+835.81+513.347+835.81C661.919+835.81+780.014+717.714+780.014+569.143C780.014+420.571+661.919+302.476+513.347+302.476Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.913+136.218L571.781+136.218C592.61+136.218+609.495+153.103+609.495+173.932L609.495+174.694C609.495+195.523+592.61+212.408+571.781+212.408L454.913+212.408C434.084+212.408+417.199+195.523+417.199+174.694L417.199+173.932C417.199+153.103+434.084+136.218+454.913+136.218Z",
    opacity: 1,
    fill: "#2facec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.912+188.19L551.782+188.19L551.782+264.381L474.912+264.381L474.912+188.19Z",
    fill: "#2facec",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M475.252+502.677C475.252+502.677+494.215+357.748+513.347+357.847C532.48+357.946+551.782+503.072+551.782+503.072L551.442+607.238L475.252+607.238L475.252+502.677Z",
    fill: "#ffb400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.044+306.528L748.056+268.467C755.313+260.577+769.517+258.867+778.213+263.483L807.954+291.765C813.879+300.688+812.224+314.412+804.758+322.104L769.993+357.921C762.528+365.613+750.023+366.028+742.064+358.848L714.315+333.814C706.356+326.634+705.787+314.417+713.044+306.528Z",
    opacity: 1,
    fill: "#2facec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.347+492.952C471.268+492.952+437.157+527.064+437.157+569.143C437.157+611.222+471.268+645.333+513.347+645.333C555.426+645.333+589.538+611.222+589.538+569.143C589.538+527.064+555.426+492.952+513.347+492.952Z",
    opacity: 1,
    fill: "#ffb400"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1a6ac9",
    d: "M513.347+524.143C488.494+524.143+468.347+544.29+468.347+569.143C468.347+593.996+488.494+614.143+513.347+614.143C538.2+614.143+558.347+593.996+558.347+569.143C558.347+544.29+538.2+524.143+513.347+524.143Z",
    opacity: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopwatch);
export default __webpack_public_path__ + "static/media/Stopwatch.d3a707e3898efe93119da666db14441a.svg";
export { ForwardRef as ReactComponent };